import { faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TFunction } from 'i18next'
import React, { FC, useContext } from 'react'
import { Button, Nav, Navbar, OverlayTrigger, Popover } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import AppContext from '../Authentication/AppContext'
import AuthService from '../Authentication/AuthService'
import DialogContext from '../Authentication/DialogContext'
import { EditDialogProps } from '../components/EditDialog'
import LoginService from '../service/LoginService'

export const Header: FC<{}> = () => {
  const { auth, needsPasswordChange, isAdUser, refreshUserDetails } = useContext(AppContext)
  const { editDialogPropsSetter } = useContext(DialogContext)
  const { t } = useTranslation()

  const overlayPopover = (
    <Popover id='adminBugerMenu'>
      <Popover.Content>
        {!needsPasswordChange && !isAdUser && (
          <Nav.Link onClick={() => updatePassword(t, editDialogPropsSetter, refreshUserDetails)}>{t('changePassword')}</Nav.Link>
        )}
        <Nav.Link href='./logout'>{t('logout')}</Nav.Link>
        <Nav.Link target='_blank' href={`${window.location.origin}/onASConsole/login`} rel='noopener noreferrer'>
          {t('switchToOldUI')}
        </Nav.Link>
      </Popover.Content>
    </Popover>
  )

  return (
    <>
      <Navbar variant='dark' bg='dark' className='mb-0 shadow-sm header p-2'>
        <Navbar.Brand>
          <img src='./eperi_fav.png' style={{ height: '2em' }} alt='eperi' />
        </Navbar.Brand>
        <Navbar.Collapse>
          <Navbar.Text as='h1'>{t('egfca', 'eperi Gateway for Cloud Apps')}</Navbar.Text>
        </Navbar.Collapse>
        {auth && (
          <OverlayTrigger rootClose={true} trigger='click' placement='bottom' overlay={overlayPopover}>
            <Button variant='link' className='text-primary pr-3 cursor-pointer'>
              <FontAwesomeIcon icon={faUser} /> {AuthService.getLoggedinUser(auth)}
            </Button>
          </OverlayTrigger>
        )}
      </Navbar>
      <hr className='bg-primary pt-1 mt-0 mb-0' />
    </>
  )
}

export function updatePassword(t: TFunction, editDialogPropsSetter: any, refreshUserDetails: () => void, cancelable?: boolean) {
  const editDialogProps: EditDialogProps = {
    show: true,
    header: t('passwordUpdate.Header'),
    labelGridSize: 3,
    onSubmit: LoginService.updatePassword,
    onSubmitExtraArgs: [t, refreshUserDetails],
    showCancelButton: cancelable,
    showCloseButton: cancelable,
    data: [
      {
        id: 'oldPassword',
        type: 'password',
        label: t('passwordUpdate.oldPassword'),
        autoComplete: 'current-password',
        placeholder: t('passwordUpdate.oldPassword'),
        requiredMessage: t('passwordUpdate.inValidMessage'),
        required: true,
      },
      {
        id: 'newPassword',
        type: 'password',
        label: t('passwordUpdate.newPassword'),
        autoComplete: 'new-password',
        placeholder: t('passwordUpdate.newPassword'),
        requiredMessage: t('passwordUpdate.inValidMessage'),
        required: true,
      },
      {
        id: 'confirmPassword',
        type: 'password',
        label: t('passwordUpdate.confirmPassword'),
        placeholder: t('passwordUpdate.confirmPassword'),
        autoComplete: 'new-password',
        requiredMessage: t('passwordUpdate.inValidMessage'),
        required: true,
      },
    ],
  }

  editDialogPropsSetter(editDialogProps)
}
